import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from "react"
import { Button, Form, Input, Col, Row, message, Select, Switch, Upload, Card } from "antd"
import { insertSystem, editSystem, getSystemOne } from "@/service/maintenanceService"
import BraftEditor from "braft-editor"
import { ContentUtils } from "braft-utils"
import { getToken } from "@/utils/dataStorage"
import { fileUploadUrl, fileLookUrl } from "@/config/app.js"

const { Option } = Select
const SystemDetails = (props) => {
    const {t} = useTranslation()
    const { modeKey, dispatch, mode, rowInfo } = props
    const [form] = Form.useForm()
    const [editorState, setEditorState] = useState(BraftEditor.createEditorState(null)) //富文本
    const [choseConType, setChoseConType] = useState()
    const [confType, setConfType] = useState([])

    useEffect(() => {
        resetFormItem()
        _getConfType()
    }, [])
    //移动车表单提交
    const systemSubmit = () => {
        form.validateFields().then((values) => {
            let data = {
                ...values,
                disableFlag: values.disableFlag ? 0 : 1,
                confVal: choseConType !== "rich_text" ? values.confVal : editorState.toHTML(),
            }
            //新增
            if (mode === "insert") {
                insertSystem(data).then((res) => {
                    // if (res && res.retCode === 200) {
                    handleCancel()
                    message.success(t(`dataManage.systemConfig.systemDetails.新增成功`))
                    // } else {
                    //     message.error(res.retMsg)
                    // }
                })
                // .catch((err) => {
                //     message.error(err.retMsg)
                // })
                //编辑
            } else if (mode === "edit") {
                editSystem({ ...data, id: rowInfo.id }).then((res) => {
                    // if (res && res.retCode === 200) {
                    handleCancel()
                    message.success(t(`dataManage.systemConfig.systemDetails.编辑成功`))
                    // } else {
                    //     message.error(res.retMsg)
                    // }
                })
                // .catch((err) => {
                //     message.error(err.retMsg)
                // })
            }
        })
    }

    //获取系统配置信息
    const _getConfType = () => {
        // getConfType().then(res => {
        //     if (res && res.retCode === 200) {
        //         setConfType(res.retData)
        //     }
        // })
        setConfType([
            { tag: "number", desc: t(`dataManage.systemConfig.systemDetails.数字`) },
            { tag: "string", desc: t(`dataManage.systemConfig.systemDetails.字符串`) },
            { tag: "json_obj", desc: "json"+t(`dataManage.systemConfig.systemDetails.对象`) },
            { tag: "json_array", desc: "json"+t(`dataManage.systemConfig.systemDetails.数组`) },
            { tag: "rich_text", desc: t(`dataManage.systemConfig.systemDetails.富文本`) },
        ])
    }
    //回显表单项
    const resetFormItem = () => {
        if (mode === "edit") {
            getSystemOne(rowInfo.id).then((res) => {
                if (res && res.retCode === 200) {
                    let result = res.retData
                    // result.commodityDesc && setEditorState(BraftEditor.createEditorState(result.commodityDesc));
                    form.setFieldsValue({
                        ...res.retData,
                        disableFlag: res.retData.disableFlag === 0 ? true : false,
                    })
                    //如果是富文本
                    if (result.confType === "rich_text") {
                        setChoseConType(result.confType)
                        setEditorState(BraftEditor.createEditorState(result.confVal))
                    }
                }
            })
        } else {
            //新增默认推荐展示
            form.setFieldsValue({
                disableFlag: true,
            })
        }
    }

    //富文本上传图片
    const uploadHandler = (param) => {
        if (param.file.status === "done") {
            setEditorState(
                ContentUtils.insertMedias(editorState, [
                    {
                        type: "IMAGE",
                        url: `${fileLookUrl().image}${param?.file?.response?.retData}`,
                    },
                ])
            )
        }
    }

    const extendControls = [
        {
            key: "antd-uploader",
            type: "component",
            component: (
                <Upload
                    accept="image/*"
                    action={`${fileUploadUrl}upload/image_old`}
                    headers={{ authorization: getToken() }}
                    showUploadList={false}
                    onChange={uploadHandler}
                >
                    {}
                    <button type="button" className="control-item button upload-button" data-title= {t(`dataManage.systemConfig.systemDetails.插入图片`)}>
                         {t(`dataManage.systemConfig.systemDetails.上传图片`)}
                    </button>
                </Upload>
            ),
        },
    ]

    //富文本配置
    const controls = [
        "undo",
        "redo",
        "separator",
        "font-size",
        "line-height",
        "letter-spacing",
        "separator",
        "text-color",
        "bold",
        "italic",
        "underline",
        "strike-through",
        "separator",
        "superscript",
        "subscript",
        "remove-styles",
        "emoji",
        "separator",
        "text-indent",
        "text-align",
        "separator",
        "headings",
        "list-ul",
        "list-ol",
        "blockquote",
        "code",
        "separator",
        "link",
        "separator",
        "hr",
        "separator",
        // 'media', 'separator',
        "clear",
    ]
    const formItemLayout = {
        labelCol: {
            offset: 2,
        },
        wrapperCol: {
            offset: 2,
        },
    }
    //取消
    const handleCancel = () => {
        dispatch({
            type: "removeTabs",
            targetKey: modeKey,
            activeMenu: "systemConfig",
        })
    }
    //类型切换
    const handleconfTypeChange = (val) => {
        setChoseConType(val)
    }
    return (
        <>
            <div className="toolbar">
                <span className="modules-name"> {t(`dataManage.systemConfig.systemDetails.系统配置`)}</span>
            </div>
            <div className="list-container">
                <div className="list-header">
                    <div className="list-name">
                        <span> {t(`dataManage.systemConfig.systemDetails.系统配置信息`)}</span>
                    </div>
                    <div className="list-but">
                        <Button type="primary" shape="round" size="small" className="but-left" onClick={systemSubmit}>
                             {t(`dataManage.systemConfig.systemDetails.保存`)}
                        </Button>
                        <Button type="primary" shape="round" size="small" className="but-left" onClick={handleCancel}>
                             {t(`dataManage.systemConfig.systemDetails.取消`)}
                        </Button>
                    </div>
                </div>
                <div className="form-details-warp">
                    <Form  layout="vertical" form={form} {...formItemLayout}>
                        <Row gutter={100}>
                            <Col offset={3} span={9}>
                                <Form.Item
                                    label= {t(`dataManage.systemConfig.systemDetails.配置的`)+"key"}
                                    name="confKey"
                                    rules={[
                                        {
                                            required: true,
                                            message: t(`dataManage.systemConfig.systemDetails.配置的`)+ "key" + t(`dataManage.systemConfig.systemDetails.不可为空`),
                                        },
                                    ]}
                                >
                                    <Input placeholder= {t(`dataManage.systemConfig.systemDetails.请输入配置的`) +"key"} />
                                </Form.Item>
                            </Col>
                            <Col span={9}>
                                <Form.Item
                                    label= {t(`dataManage.systemConfig.systemDetails.配置的值`)}
                                    name="confVal"
                                    rules={[
                                        {
                                            required: choseConType !== "rich_text",
                                            message: t(`dataManage.systemConfig.systemDetails.配置的不可为空`),
                                        },
                                    ]}
                                >
                                    <Input placeholder= {t(`dataManage.systemConfig.systemDetails.请输入配置的值`)} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={100}>
                            <Col offset={3} span={9}>
                                <Form.Item
                                    label= {t(`dataManage.systemConfig.systemDetails.配置类型`)}
                                    name="confType"
                                    rules={[
                                        {
                                            required: true,
                                            message: t(`dataManage.systemConfig.systemDetails.请选择配置类型`),
                                        },
                                    ]}
                                >
                                    <Select showSearch allowClear placeholder= {t(`dataManage.systemConfig.systemDetails.请选择配置类型`)} style={{ width: "100%" }} onChange={handleconfTypeChange}>
                                        {confType.map((item) => (
                                            <Option value={item.tag} key={item.tag}>
                                                {item.desc}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={9}>
                                <Form.Item label= {t(`dataManage.systemConfig.systemDetails.备注`)} name="remark">
                                    <Input placeholder= {t(`dataManage.systemConfig.systemDetails.请输入备注`)} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={100}>
                            <Col offset={3} span={9}>
                                <Form.Item name="disableFlag" label= {t(`dataManage.systemConfig.systemDetails.使用状态`)} valuePropName="checked">
                                    <Switch checkedChildren= {t(`dataManage.systemConfig.systemDetails.开启`)} unCheckedChildren= {t(`dataManage.systemConfig.systemDetails.关闭`)} />
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </div>
                {choseConType === "rich_text" ? (
                    <Row>
                        <Col span={24}>
                            <Card title= {`${t(`dataManage.systemConfig.systemDetails.富文本值`)}:`}>
                                <BraftEditor value={editorState} controls={controls} onChange={(e) => setEditorState(e)} extendControls={extendControls} />
                            </Card>
                        </Col>
                    </Row>
                ) : (
                    <></>
                )}
            </div>
        </>
    )
}
export default SystemDetails
